// pages/ErrorPage.js
import React from "react";

const ErrorPage = () => {
  return (
    <div style={{ padding: "2rem", color: "red" }}>
      <h2>エラーが発生しました</h2>
      <p>ログインに失敗しました。もう一度お試しください。</p>
    </div>
  );
};

export default ErrorPage;